import { apiConfig } from './config';
import { CustomersApi } from './swagger/apis/customers-api';

class CustomersService extends CustomersApi {
  constructor(_apiConfig: any) {
    super(_apiConfig);
  }

  // En tu servicio CustomersService
  async getFilteredCustomers({ customerId, businessName, companyId, vatNumber }: any) {
    const accessToken = `Bearer ${localStorage.getItem('ef-token') as string}`;

    // Solo agregamos params que tengan valor
    const params: any = {};
    if (customerId) params.customerId = customerId;
    if (businessName) params.businessName = businessName;
    if (companyId) params.companyId = companyId;
    if (vatNumber) params.vatNumber = vatNumber;

    return this.customersGetFiltered({
      headers: { Authorization: accessToken },
      params,
    });
  }
}

export const customersService = new CustomersService(apiConfig);
